import Cookies from 'js-cookie'
import { createI18n } from 'vue-i18n'

// TODO(Vue3): refactor I118n installation: https://vue-i18n.intlify.dev/guide/migration/vue3/

function loadLocaleMessages() {
  const locales = require.context('./locales', false, /[a-z]+\.json$/i)
  const messages = {}

  locales.keys().forEach((l) => {
    const code = l.slice(2).split('.')[0]
    messages[code] = require(`./locales/${code}.json`)
  })

  return messages
}

const i18n = createI18n({
  locale: Cookies.get('lang') || 'ru',
  legacy: false,
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
  globalInjection: true,
  silentTranslationWarn: true,
  pluralRules: {
    ru(choice) {
      if (choice === 0) {
        return 2
      }
      const teen = choice > 10 && choice < 20
      const endsWithOne = choice % 10 === 1
      const endsWithTwoToFour = choice % 10 >= 2 && choice % 10 <= 4

      if (teen) {
        return 2
      }
      if (endsWithOne) {
        return 0
      }
      if (endsWithTwoToFour) {
        return 1
      }
      return 2
    },
  },
})

export default i18n
